import {
  Box,
  BoxProps,
  ButtonProps,
  IconButton,
  Loader,
  ModalDialog,
  ModBox,
  Spacer,
  TextNew,
  TextNewProps,
} from '@jfs/ui-new'
import { ButtonNew } from '../../../../../components/AdminButton'
import { useCallback, useEffect, useState } from 'react'
import { TextInputLabelToolTip } from '../../../../../components/TextInputLabelToolTip'
import { RootStore, useLazyApiData, useStores } from '../../../../../data/store'
import { dateFormatter, DateFormatTypes } from '../../../../../utils'
import { EmType } from '../../../../EntityManagement'
import { SelectParentEntityList } from '../../../../EntityManagement/Onboarding/CreateEntity/SelectParentEntityList'
import { MultipleDocsView } from '../../../../EntityManagement/Onboarding/Documentation/MultipleDocsView'
import { DocumentationView } from '../../../../EntityManagement/Onboarding/Documentation/View'
import { UploadFileModal } from './UploadFileModal'

interface UploadEntityFileProps {
  rowData: any[]
  uploadButtonTitle: string
  uploadDialogTitle: string
  uploadFileReqMapper: any
  uploadFileReqConstants: any
  documentListHeaderMapper: any
  nonEditableTitle: string
  editable: boolean
  optionalFields?: any[]
  hintMessage?: string
  acceptMultiple?: boolean
  uploadId: any
  docCategoryLov: any
  documentCategoriesSupported?: string[]
  jdmsTableColumns: string[]
  hideColumnsJdms
  categoryFieldName?: string
}

export const UploadEntityFile = ({
  rowData,
  uploadButtonTitle,
  uploadDialogTitle,
  uploadFileReqMapper,
  uploadFileReqConstants,
  documentListHeaderMapper,
  nonEditableTitle,
  editable,
  optionalFields = [],
  acceptMultiple = false,
  uploadId,
  hintMessage = '** Upload atleast one supported document to proceed',
  docCategoryLov,
  documentCategoriesSupported,
  jdmsTableColumns,
  hideColumnsJdms,
  categoryFieldName,
  ...formProps
}: UploadEntityFileProps) => {
  const { kycDocumentsList, deleteKycDoc, documentTypeData } = useStores((store) => ({
    kycDocumentsList: store.kycDocumentsList,
    deleteKycDoc: store.entityOnboarding.deleteKycDoc,
    documentTypeData: store.documentCategories,
  }))
  const [selectedDocument, setSelectedDocument] = useState(null)
  console.log('htag formProps', formProps?.allValues?.changeHistory?.[formProps?.fieldName + '_docs_data'])
  console.log('htag formProps', formProps?.allValues?.changeHistory)
  console.log('htag formProps', formProps?.fieldName)
  const [showUploadModel, setShowUploadModel] = useState(false)
  const [showDocViewModal, setShowDocViewModal] = useState(false)
  const [validationStatus, setValidationStatus] = useState(rowData.map(() => true))
  const [_, setRefresh] = useState(false)

  const [fetchKycDocsList, fetchKycDocsHandler] = useLazyApiData(kycDocumentsList)
  const [deleteKycDocApi, deleteKycDocHandler] = useLazyApiData(deleteKycDoc)
  const docUploadedDataKey = `${formProps?.fieldName}_docs_data`
  const jdmsUploadedDocsKey = `${formProps?.fieldName}_docs_data_jdms`
  const changeHistory = formProps?.allValues?.changeHistory?.[formProps?.fieldName + '_docs_data']?.at(-1)
  const formattedChangedHistoryData = changeHistory?.updatedAt
    ? 'Last Updated By : ' +
      changeHistory?.user?.username +
      '||' +
      'Last Updated At : ' +
      dateFormatter(changeHistory?.updatedAt, DateFormatTypes.DATE_AM_PM)
    : ''

  useEffect(() => {
    if (deleteKycDocHandler.state === 'fulfilled') {
      fetchKycDocsList(uploadId, uploadFileReqConstants.uploadType, 'DOCUMENT_UPLOADED', true)
    }
  }, [deleteKycDocHandler.state])

  const onDismiss = useCallback(() => {
    setShowUploadModel(false)
    fetchKycDocsList(uploadId, uploadFileReqConstants.uploadType, 'DOCUMENT_UPLOADED')
  }, [fetchKycDocsList, uploadFileReqConstants.uploadType, uploadId])

  const onUploadButtonPress = useCallback(() => setShowUploadModel(true), [])

  const filteredOptionalFields = optionalFields
    .filter((item) => {
      if (typeof item === 'object') {
        const exception =
          item.exceptions?.every((exceptionItem) => {
            const exceptionFieldKey = exceptionItem?.key ?? ''
            const exceptionItemValue = RootStore?.documentCategories?.find(
              (doc) => doc.value === formProps.allValues?.[exceptionFieldKey],
            )?.key
            return exceptionItem?.values?.includes(exceptionItemValue)
          }) ?? false
        return !exception
      }
      return true
    })
    .map((item) => {
      if (typeof item === 'object') {
        return item?.key
      }
      return item
    })

  const showUploadButton = useCallback(() => {
    return rowData?.every(({ fieldName }, index) => {
      return (
        (formProps?.allValues?.[fieldName] && validationStatus[index]) || filteredOptionalFields.includes(fieldName)
      )
    })
  }, [formProps])
  const keysToKeep = [...documentListHeaderMapper.map((item) => item.key), 'RID', 'uploadId']

  const onDeletePress = useCallback((item: any) => {
    console.log(item)
    deleteKycDocApi(item.uploadId, item.RID)
  }, [])

  const addDefaultValues = useCallback((obj: any) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
          obj[key] = 'NA'
        }
      }
    }
    return obj
  }, [])

  const documentList = formProps?.allValues?.[docUploadedDataKey] ? formProps?.allValues?.[docUploadedDataKey] : []

  const jdmsDocList = formProps?.allValues?.[jdmsUploadedDocsKey] ?? []

  console.log('jdmsDocList =', jdmsDocList)

  const documentComponentData = documentList.map((item) => ({
    ...item,
    custom: editable ? <DeleteComponent isLoading={false} onDeletePress={() => onDeletePress(item)} /> : null,
  }))

  const onItemPress = useCallback((item: any) => {
    console.log('item=', item)
    setShowDocViewModal(true)
    setSelectedDocument(item)
  }, [])

  const onBackPress = () => {
    setShowDocViewModal(false)
  }

  useEffect(() => {
    if (fetchKycDocsHandler.state === 'fulfilled') {
      formProps?.setFieldValue(
        docUploadedDataKey,
        fetchKycDocsHandler?.data
          ?.filter((item) =>
            documentCategoriesSupported
              ? documentCategoriesSupported.includes(item?.MERCHANT_DOCUMENT_TYPE)
              : !['POA', 'POB', 'POI', 'CC', 'FS', 'RISK'].includes(item?.MERCHANT_DOCUMENT_TYPE),
          )
          ?.map((item) => Object.fromEntries(Object.entries(item).filter(([key]) => keysToKeep.includes(key))))
          ?.map((item) => ({
            ...addDefaultValues(item),
          })) ?? [],
      )
      setRefresh((last) => !last)
    }
  }, [fetchKycDocsHandler?.data?.length, fetchKycDocsHandler.state])

  console.log('htag fofetchKycDocsHandler?.data ', fetchKycDocsHandler?.data)
  console.log('htag formProps= ', formProps)

  return (
    <Box>
      <ModBox show={editable}>
        <Box flexDirection={'row'} paddingBottom={8}>
          {rowData.map(({ ComponentName, ...props }, index) => {
            return (
              <Box flex={1} marginHorizontal={8}>
                <ComponentName
                  setFieldValue={formProps?.setFieldValue}
                  touched={true}
                  {...props}
                  error={
                    ((documentComponentData?.length === 0 && jdmsDocList?.length === 0 && !formProps.isOptional) ||
                      !!formProps?.allValues?.[categoryFieldName]) &&
                    (!formProps?.allValues?.[props.fieldName] || !validationStatus[index]) &&
                    !filteredOptionalFields.includes(props?.fieldName) &&
                    'required!'
                  }
                  onValidationChange={(isValid: boolean) => {
                    setValidationStatus([
                      ...validationStatus.slice(0, index),
                      isValid,
                      ...validationStatus.slice(index + 1),
                    ])
                  }}
                  onChange={(data) => formProps?.setFieldValue(props.fieldName, data)}
                  value={formProps?.allValues?.[props.fieldName]}
                  allValues={formProps?.allValues}
                  editable={acceptMultiple || documentComponentData?.length === 0}
                  disabled={!acceptMultiple && documentComponentData?.length > 0}
                  selectable={acceptMultiple || documentComponentData?.length === 0}
                />
              </Box>
            )
          })}
        </Box>
        {showUploadButton() && (
          <>
            <ButtonNew {...styles.uploadButton} title={uploadButtonTitle} onPress={onUploadButtonPress} />
          </>
        )}
        {showUploadButton() && fetchKycDocsHandler?.state !== 'pending' && documentList?.length === 0 && (
          <TextNew {...styles.error}>{hintMessage}</TextNew>
        )}
        <Spacer size={8} direction="vertical" />
        {showUploadModel && (
          <UploadFileModal
            show={showUploadModel}
            documentTypeData={documentTypeData}
            docCategoryLov={docCategoryLov}
            onDismiss={onDismiss as any}
            {...formProps}
            title={uploadDialogTitle}
            uploadFileReqMapper={uploadFileReqMapper}
            uploadFileReqConstants={uploadFileReqConstants}
            uploadId={uploadId}
          />
        )}
      </ModBox>
      <ModBox show={!editable} marginBottom={16}>
        <TextNew {...styles.nonEditableTitle}>{nonEditableTitle}</TextNew>
        <ModBox marginTop={8} show={documentComponentData?.length === 0 && jdmsDocList?.length === 0}>
          <TextNew {...styles.noDocText}>No Documents available.</TextNew>
        </ModBox>
      </ModBox>
      <Box pt={8} pb={16}>
        <ModBox show={documentComponentData?.length > 0}>
          <TextInputLabelToolTip
            label=" "
            touched={false}
            modalDetails={{ data: formattedChangedHistoryData }}
            editable={false}
            focusBorderColor={'TRANSPARENT'}
            minHeight={0}
            fontSize={0}
            labelPaddingBottom={0}
            bgColor={'TRANSPARENT'}
          />
        </ModBox>
        <SelectParentEntityList
          title={'Uploaded Docs'}
          hide={documentComponentData?.length === 0}
          data={documentComponentData}
          headerTitles={documentListHeaderMapper?.map((item) => ({ title: item?.header }))}
          columnFlexMapper={columnFlexMapper}
          onDelete={() => {
            console.log('onDelete')
          }}
          onItemPress={onItemPress}
          onDownloadPress={() => {
            console.log('onDownloadPress')
          }}
          hideColumnNames={['uploadId', 'RID']}
        />
        <Spacer size={20} direction="vertical" />

        <SelectParentEntityList
          title={'Existing Docs'}
          hide={jdmsDocList?.length === 0}
          data={jdmsDocList}
          headerTitles={jdmsTableColumns?.map((item) => ({ title: item }))}
          columnFlexMapper={
            {
              0: 2,
              1: 1,
              2: 1,
              3: 1,
              4: 1,
              5: 1,
              6: 1,
              7: 1,
            } as any
          }
          onItemPress={onItemPress}
          onDownloadPress={onItemPress}
          hideColumnNames={hideColumnsJdms}
        />
      </Box>
      <ModalDialog
        type="CenteredWrap"
        show={showDocViewModal}
        onDismiss={() => setShowDocViewModal(false)}
        onClose={() => setShowDocViewModal(false)}>
        <>
          <ModBox show={selectedDocument?.kycDocuments ? true : false}>
            <MultipleDocsView
              item={selectedDocument}
              flowType={EmType.entityOnboarding}
              onBackPress={onBackPress}
              entityId={formProps?.allValues?.entityId}
            />
          </ModBox>
          <ModBox show={!selectedDocument?.kycDocuments ? true : false}>
            <DocumentationView
              entityId={''}
              documentName={selectedDocument?.NAME ?? ''}
              type={
                selectedDocument?.NAME?.includes('.pdf') || selectedDocument?.NAME?.includes('.PDF')
                  ? 'PDF'
                  : selectedDocument?.NAME?.includes('.png') || selectedDocument?.NAME?.includes('.PNG')
                  ? 'PNG'
                  : selectedDocument?.NAME?.includes('.jpg') || selectedDocument?.NAME?.includes('.JPG')
                  ? 'JPG'
                  : selectedDocument?.NAME?.includes('.JPEG') || selectedDocument?.NAME?.includes('.jpeg')
                  ? 'JPG'
                  : `${selectedDocument?.NAME?.split('.')?.[1]}`
              }
              onBackPress={onBackPress}
              item={selectedDocument}
              flowType={EmType.entityOnboarding}
              onReplacePress={() => {}}
              applicationStatus={''}
            />
          </ModBox>
        </>
      </ModalDialog>
    </Box>
  )
}

const columnFlexMapper: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 0.2,
  5: 0.2,
  6: 1,
  7: 1,
}

const styles = {
  container: {
    marginTop: 28,
  } as BoxProps,
  uploadButton: {
    type: 'secondaryFullWidth',
    icon: 'UPLOAD',
    borderColor: 'PRIMARY',
    borderRadius: 4,
    height: 32,
  } as ButtonProps,
  error: {
    fontFamily: 'jioType-bold',
    fontSize: 10,
    color: 'TEXT_ERROR',
  } as TextNewProps,
  nonEditableTitle: {
    fontFamily: 'jioType-medium',
    fontSize: 14,
    color: 'BLACK_75',
  } as TextNewProps,
  noDocText: {
    fontSize: 12,
    color: 'BLACK_21',
  } as TextNewProps,
}

const DeleteComponent = ({ isLoading, onDeletePress }) => {
  return (
    <Box>
      {isLoading && <Loader color="PRIMARY" />}
      {!isLoading && <IconButton id="DELETE" color="PRIMARY" onPress={onDeletePress} />}
    </Box>
  )
}
